import { useState, useEffect, useRef } from "react";
import supabase from '../supabaseClient';

export const BotAdmin = () => {
  const [abierto, setAbierto] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [mensajes, setMensajes] = useState([]);
  const [cargando, setCargando] = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => {
    if (abierto && mensajes.length === 0) {
      // No cargamos historial — cada sesión empieza limpia
      setMensajes([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [abierto]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [mensajes]);

  const enviar = async () => {
    if (!mensaje.trim() || cargando) return;
    const texto = mensaje.trim();
    setMensaje("");
    setMensajes(prev => [...prev, { rol: "user", texto }]);
    setCargando(true);
    try {
      const { data: { session } } = await supabase.auth.getSession();
      const r = await fetch("https://fmzyvyhgqhrpfpsdwtcu.supabase.co/functions/v1/chat-admin", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${session?.access_token}` },
        body: JSON.stringify({ mensaje: texto })
      });
      const data = await r.json();
      setMensajes(prev => [...prev, { rol: "assistant", texto: data.respuesta || data.error || "Error al conectar con el asistente." }]);
    } catch {
      setMensajes(prev => [...prev, { rol: "assistant", texto: "Error al conectar con el asistente." }]);
    }
    setCargando(false);
  };

  return (
    <>
      {/* Botón flotante */}
      <button
        onClick={() => setAbierto(a => !a)}
        style={{ position: "fixed", bottom: 24, right: 24, zIndex: 50, width: 56, height: 56, borderRadius: "50%", background: "linear-gradient(135deg,#0f172a,#0ea5e9)", border: "none", cursor: "pointer", boxShadow: "0 4px 20px rgba(14,165,233,0.5)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24 }}
      >
        {abierto ? "✕" : "💬"}
      </button>

      {/* Panel de chat */}
      {abierto && (
        <div style={{ position: "fixed", bottom: 90, right: 24, zIndex: 50, width: 340, height: 480, background: "white", borderRadius: 16, boxShadow: "0 8px 40px rgba(0,0,0,0.2)", display: "flex", flexDirection: "column", overflow: "hidden", border: "1px solid #e5e7eb" }}>
          {/* Header */}
          <div style={{ background: "linear-gradient(90deg,#0f172a,#1e3a5f)", padding: "12px 16px", display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ fontSize: 20 }}>💬</span>
            <div>
              <p style={{ color: "white", fontWeight: 700, fontSize: 14, margin: 0 }}>Asistente WareHausePlan</p>
              <p style={{ color: "#93c5fd", fontSize: 11, margin: 0 }}>Consulta el estado del almacén</p>
            </div>
          </div>

          {/* Mensajes */}
          <div style={{ flex: 1, overflowY: "auto", padding: 12, display: "flex", flexDirection: "column", gap: 8 }}>
            {mensajes.length === 0 && !cargando && (
              <div style={{ textAlign: "center", color: "#9ca3af", fontSize: 12, marginTop: 40 }}>
                <p style={{ fontSize: 32, marginBottom: 8 }}>👋</p>
                <p>Hola, soy tu asistente de almacén.<br />Pregúntame lo que necesites.</p>
              </div>
            )}
            {mensajes.map((m, i) => (
              <div key={i} style={{ display: "flex", justifyContent: m.rol === "user" ? "flex-end" : "flex-start" }}>
                <div style={{ maxWidth: "80%", padding: "8px 12px", borderRadius: m.rol === "user" ? "12px 12px 0 12px" : "12px 12px 12px 0", background: m.rol === "user" ? "linear-gradient(90deg,#0ea5e9,#0369a1)" : "#f3f4f6", color: m.rol === "user" ? "white" : "#1f2937", fontSize: 13, lineHeight: 1.5 }}>
                  {m.texto}
                </div>
              </div>
            ))}
            {cargando && (
              <div style={{ display: "flex", justifyContent: "flex-start" }}>
                <div style={{ background: "#f3f4f6", borderRadius: "12px 12px 12px 0", padding: "8px 12px", fontSize: 13, color: "#6b7280" }}>⏳ Pensando...</div>
              </div>
            )}
            <div ref={bottomRef} />
          </div>

          {/* Input */}
          <div style={{ padding: "8px 12px", borderTop: "1px solid #e5e7eb", display: "flex", gap: 8 }}>
            <input
              style={{ flex: 1, border: "1px solid #d1d5db", borderRadius: 10, padding: "8px 12px", fontSize: 13, outline: "none" }}
              placeholder="Escribe tu pregunta..."
              value={mensaje}
              onChange={e => setMensaje(e.target.value)}
              onKeyDown={e => e.key === "Enter" && enviar()}
            />
            <button
              onClick={enviar}
              disabled={cargando || !mensaje.trim()}
              style={{ background: "linear-gradient(90deg,#0ea5e9,#0369a1)", color: "white", border: "none", borderRadius: 10, padding: "8px 14px", fontWeight: 700, fontSize: 13, cursor: "pointer", opacity: cargando || !mensaje.trim() ? 0.5 : 1 }}
            >
              →
            </button>
          </div>
        </div>
      )}
    </>
  );
};
